<template>
  <div class="point-time" v-if="currentTime" @click="changeTime">
    <img src="@/assets/img/bficon.png" />
    <span>{{ getTime(currentTime) }}</span>
  </div>
</template>

<script>
export default {
  props: ["currentTime"],
  data() {
    return {};
  },
  methods: {
    padTo2Digits(num) {
      return num.toString().padStart(2, "0");
    },
    getTime(val) {
      if (val) {
        // 👇️ 获取完整分钟数
        const minutes = Math.floor(val / 60);
        // 👇️ 获得剩余的秒数
        const seconds = Math.floor(val % 60);
        return `${this.padTo2Digits(minutes)}:${this.padTo2Digits(seconds)}`;
      }
    },
    changeTime() {
      this.$emit("changeTime");
    },
  },
};
</script>

<style scoped lang="scss">
.point-time {
  display: flex;
  align-items: center;
  margin-top: 2px;
  cursor: pointer;
  > span {
    border: 1px solid #dcdee0;
    border-left: 0;
    line-height: 14px;
    height: 16px;
    padding: 0 8px;
  }
}
</style>
